export const DIRECT_DEBIT_QUERY_KEYS = {
  all: ["direct-debit"] as const,
  situation: () => [...DIRECT_DEBIT_QUERY_KEYS.all, "situation"] as const,
  bankAccountRequest: (id: number) => [...DIRECT_DEBIT_QUERY_KEYS.all, "bank-account-request", id] as const,
  paymentRequest: (id: number) => [...DIRECT_DEBIT_QUERY_KEYS.all, "payment-request", id] as const,
} as const;
